/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentResponse {
    getFixupPrototypeFunction() { return AgentResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentResponse>): AgentResponse {
        let obj = Object.assign(new AgentResponse(), model);
        AgentResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentResponse>): AgentResponse {
        if (!model) return null;
        return AgentResponse.newInstance(<AgentResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentResponse) {
        if (!obj) return;

        models.AgentResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentResponse): boolean {
        Object.setPrototypeOf(obj, AgentResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.response) {
            for (let val of this.response) {
                models.BaseForAgentResponse.fixupPrototype(val);
            }
        }
    }

    /**
     * Response from the agent
     */
    response: Array<models.BaseForAgentResponse>;

    /**
     * Status of the response
     */
    status: models.AgentResponseStatus;

}
